import { router } from '../router';

export const goto = (path: string) => {
  router.navigate(path);
};
